var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
var FechaAgregadoEnLista = function (_a) {
    var producto = _a.producto;
    return (React.createElement(InformacionDeFechaDeCreado, null,
        "Agregado ",
        producto.agregadoPor && "por ".concat(producto.agregadoPor),
        " el",
        " ",
        producto.fechaAgregadoLista && producto.fechaAgregadoLista));
};
var InformacionDeFechaDeCreado = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 12px;\n  margin: 0 0 10px 0;\n  padding: 0;\n  color: gray;\n"], ["\n  font-size: 12px;\n  margin: 0 0 10px 0;\n  padding: 0;\n  color: gray;\n"])));
export default FechaAgregadoEnLista;
var templateObject_1;
